export default "__VITE_ASSET__BQMvoD6f__"